/* @flow */
import * as React from 'react';
import moment from 'moment';

//----------------------------------------------------------------------//
// GLOBAL COMPONENTS                                                    //
//----------------------------------------------------------------------//

import AppCopyrightInfo from 'components/AppCopyrightInfo/AppCopyrightInfo';
import AutoWrapper from 'components/AutoWrapper/AutoWrapper';

//----------------------------------------------------------------------//
// CSS                                                                  //
//----------------------------------------------------------------------//

import styles from './PageWrapper.module.scss';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

export type TypeProps = {|
  children: React.Node,
  isAuto?: boolean,
  isFilters?: boolean,
  isFlex?: boolean,
  accountLastSyncMoment?: moment,
|};

export default class PageWrapper extends React.Component<*> {
  static defaultProps = {
    isAuto: false,
    isFilters: false,
    isFlex: true,
  };

  renderAuto(children: Array<*>): React.Element<*> {
    return <AutoWrapper>{children}</AutoWrapper>;
  }

  render(): React.Element<*> {
    const { children, isFilters, isFlex }: TypeProps = this.props;
    const hasFlex: string = isFlex ? styles['has-flex'] : '';

    // TODO: Rename this as this actually means whether or not the filter drawer is open
    const hasFilters: string = isFilters ? styles['has-filters'] : '';

    return (
      <div className={`${styles['page-wrapper']} ${hasFlex} ${hasFilters}`}>
        {this.props.isAuto ? this.renderAuto(children) : children}
        {<AppCopyrightInfo accountLastSyncMoment={this.props.accountLastSyncMoment} />}
      </div>
    );
  }
}
